import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Sidebar from "../../partials/aside/Sidebar";
import { Redirect, Link } from "react-router-dom";
import httpService from "../../../services/httpServices/httpServices";
import authorizedComponent from "../../../helpers/authorized-component";

function AllRoles() {
  const [roles, setRoles] = useState();

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    let roles = await sendRequestGetRoles();
    if (roles != false) {
      setRoles(generateTagsRoles(roles));
    }
  };

  const sendRequestGetRoles = async () => {
    const headersRequest = getHeaderForRequset();
    let roles;
    try {
      roles = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return roles.data.data;
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const deleteRole = async (roleID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }

    const headersRequest = getHeaderForRequset();

    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role/" + roleID,
        headersRequest
      );
      getRoles();
    } catch (error) {
      alert(error.response.data.message);
    }
  };

  const generateTagsRoles = (roles) => {
    return roles.map((role, index) => {
      return (
        <tr>
          <td>{index + 1}</td>
          <td>{role.rol_id}</td>
          <td>{role.rol_name}</td>
          <td>{role.rol_persian_name}</td>
          <td>{role.rol_created_at}</td>

          <td>
            <div>
              <span className="pl-2">
                <Link
                  className="btn btn-outline-success  "
                  to={"/roles/edit/" + role.rol_id}
                >
                  <i className="fa fa-edit"></i>
                </Link>
              </span>

              <span>
                <span
                  className="btn btn-outline-danger  btn-danger"
                  onClick={() => deleteRole(role.rol_id)}
                >
                  <i className="fa fa-trash"></i>
                </span>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar openItem="role-permission" activeItem="role-all" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">نقش ها</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-3">
                <Link className="btn btn-outline-info" to="/roles/add">
                  <span className="pl-2">
                    <i className="fa fa-plus"></i>
                  </span>
                  <span>نقش جدید</span>
                </Link>
              </div>
              <div className="alert alert-warning">
                <span className="pl-2">
                  <i className="fa fa-exclamation-triangle	"></i>
                </span>
                <span>حد امکان از تغییر و ویرایش نام نقش خودداری کنید.</span>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-dark tbl-td-white-space ">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره نقش</td>
                      <td>نام نقش</td>
                      <td>نام فارسی</td>
                      <td>تاریخ ایجاد</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>

                  <tbody>{roles}</tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllRoles;
